import React, { MouseEventHandler } from "react";

import { useLocales } from "hooks";
import { displayDateTime } from "utils";

import { Subscription } from "./useSubscriptions";

type TextOrElement = string | JSX.Element;

interface SubscriptionsListProps {
  subscriptions: ReadonlyArray<Subscription>;
  handleDelete: (subscription: Subscription) => void;
  subscriptionIdsBeingDeleted: number[];
}

export const SubscriptionsList: React.FC<SubscriptionsListProps> = ({
  subscriptions,
  handleDelete,
  subscriptionIdsBeingDeleted,
}) => {
  const { t } = useLocales();

  const text = (text: TextOrElement | [TextOrElement, TextOrElement]) => (
    <p>
      {Array.isArray(text) ? (
        <React.Fragment>
          {text[0]}
          <span>{text[1]}</span>
        </React.Fragment>
      ) : (
        text
      )}
    </p>
  );

  const actions = (
    label: string,
    action: MouseEventHandler<HTMLAnchorElement>
  ) =>
    text(
      <a href="#" onClick={action}>
        {label}
      </a>
    );

  const bodyCell = (label: string, content: JSX.Element) => (
    <div className="card_cell">
      <span className="card_label">{t(`header.${label}`)}</span>
      {content}
    </div>
  );

  const buildHandleDelete =
    (subscription: Subscription): MouseEventHandler<HTMLAnchorElement> =>
    (event) => {
      event.preventDefault();
      handleDelete(subscription);
    };

  return (
    <div className="webpush_subscriptions_list">
      {subscriptions.map((subscription, index) => {
        const key = subscription.station_key + subscription.condition;
        const classes = `card${index % 2 ? " stripe" : ""}`;
        const beingDeleted = subscriptionIdsBeingDeleted.includes(
          subscription.id
        );
        return (
          <div key={key} className={classes}>
            {bodyCell(
              "last_measurement",
              text([
                subscription.last_value.toString(),
                subscription.unit_label,
              ])
            )}
            {bodyCell(
              "threshold",
              text([
                t(`comparison.${subscription.condition}`) +
                  " " +
                  subscription.threshold.toString(),
                subscription.unit_label,
              ])
            )}
            {bodyCell(
              "last_notification",
              text(
                displayDateTime(subscription.last_notification) ||
                  t("neverNotified")
              )
            )}
            {bodyCell(
              "actions",
              beingDeleted
                ? text(t("beingDeleted"))
                : actions("Löschen", buildHandleDelete(subscription))
            )}
          </div>
        );
      })}
    </div>
  );
};
